import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'reactstrap';

export default class PhoneNumberInput extends React.Component {
  constructor() {
    super();

    this.state = {
      value: '',
    };
  }

  handleChange(e) {
    const { value } = e.target;
    const valueWithoutDashes = value.split('-').join('');

    if (valueWithoutDashes.length > 10) {
      return;
    }
    this.setState({
      value: valueWithoutDashes,
    });
    this.props.handleChange(valueWithoutDashes);
  }

  render() {
    const { handleBlur } = this.props;
    const { value } = this.state;
    let displayValue = '';
    for (let idx = 0; idx < value.length; idx += 1) {
      if (idx === 3) {
        displayValue += '-';
      } else if (idx === 6) {
        displayValue += '-';
      }
      displayValue += value[idx];
    }
    return (
      <Input
        invalid={this.props.invalid}
        type="text"
        value={displayValue}
        placeholder="Enter a 10 digit phone number"
        onChange={e => this.handleChange(e)}
        onBlur={handleBlur}
      />
    );
  }
}

PhoneNumberInput.propTypes = {
  invalid: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/FormBuilder/CustomInputs/PhoneNumber.jsx